import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllEntregaPesquisaSatisfacaoUseCase } from "../../../presentation/useCases/read/get_all_entrega_pesquisa_satisfacao_use_case";
import { EntregaObraPesquisaSatisfacaoLista } from "../../models/entrega_obra_pesquisa_satisfacao_lista";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetAllEntregaPesquisaSatisfacaoUseCase
 */

export class GetAllEntregaPesquisaSatisfacaoUseCase
  extends BasePaginatedUseCase<EntregaObraPesquisaSatisfacaoLista>
  implements IGetAllEntregaPesquisaSatisfacaoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async execute(
    idEntregaObraCliente: number,
  ): Promise<void> {
    const result = await this.repository.getAllEntregaPesquisaSatisfacao(idEntregaObraCliente);

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;

  }
}
